<div class="audit-log-filter log-filter">
    <div fxLayout.gt-sm="row wrap" fxLayout="column wrap" fxLayoutAlign="space-between stretch">
        <div fxFlex.gt-md="1 1 40%" fxFlex.gt-sm="1 1 60%" fxFlex="1 1 100%" class="intro">
            <div>
                <p>
                    The listed events track all types of activities including all account changes and who performed each change with a
                    date/time stamp.
                </p>
                <p>Events will automatically refresh.</p>
            </div>
        </div>
    </div>
    <div fxLayout="row wrap" fxLayoutAlign="space-between stretch">
        <div fxFlex.gt-md="1 1 40%" fxFlex.gt-sm="1 1 60%" fxFlex="1 1 100%" class="intro">
            <div fxLayout="row wrap" class="mt-10" fxLayoutAlign="space-between stretch">
                <div fxFlex.gt-sm="1 1 100%" fxFlex="1 1 100%">
                    <div fxLayout="row wrap" fxLayoutAlign="space-between stretch">
                        <div fxFlex="1 1 100%">
                            <div *ngIf="logTypes.length">
                                <app-log-filter
                                    #logFilterComp
                                    [userList]="userList"
                                    [category]="logCategory"
                                    [auditTypeList]="logTypes"
                                    [initStartDate]="initStartDate"
                                    [initEndDate]="initEndDate"
                                    (logFilterChange)="filterChange($event)"
                                    (queryChange)="onQueryChange($event)"
                                ></app-log-filter>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="filter-apply">
        <app-log-filter-badget [listFilter]="logFilterDisplay" (removeFilter)="onBadgetFilterRemoved($event)"></app-log-filter-badget>
    </div>
</div>

<div class="audit-log-table-container tradition-style">
    <clare-list-view
        [isMobileView]="false"
        [hideHeader]="true"
        [callState]="callState$ | async"
        [columns]="columns"
        [source]="dataSource$ | async"
        i18n-title
        title="Audit Logs"
        [hidePagination]="true"
        [pageSize]="2000"
        [hideSearch]="true"
    >
    </clare-list-view>
</div>
